import { CSSProperties } from 'react';

export const listContainer: CSSProperties = {
  marginTop: '16px',
  marginBottom: '100px',
  background: 'linear-gradient(180deg, #F8F8FA 0%, #F4F4F6 100%)',
  minHeight: '100vh',
  paddingTop: '8px'
};
